import { useMemo } from "react";
import { motion } from "framer-motion";

const COLORS = ["#fbbf24", "#f59e0b", "#fde68a", "#fcd34d", "#eab308", "#fff7cd"];
const rand = (a, b) => a + Math.random() * (b - a);

// A one-shot golden light-burst + confetti, triggered when the Srimad
// Bhagavatam card is scratched open. Renders inside a relative, clipped parent.
export const RevealBurst = ({ show }) => {
  const parts = useMemo(
    () =>
      Array.from({ length: 46 }).map(() => ({
        x: rand(-280, 280),
        y: rand(-160, 300),
        r: rand(-260, 260),
        s: rand(0.6, 1.4),
        c: COLORS[Math.floor(Math.random() * COLORS.length)],
        d: rand(1.0, 1.8),
        w: rand(6, 12),
        h: rand(8, 16),
      })),
    []
  );

  if (!show) return null;

  return (
    <div
      data-testid="reveal-burst"
      className="pointer-events-none absolute inset-0 z-20 overflow-hidden"
    >
      {/* central light burst */}
      <motion.div
        initial={{ scale: 0, opacity: 0.85 }}
        animate={{ scale: 4, opacity: 0 }}
        transition={{ duration: 1.1, ease: "easeOut" }}
        className="absolute left-1/2 top-1/2 h-40 w-40 -translate-x-1/2 -translate-y-1/2 rounded-full bg-amber-200/70 blur-2xl"
      />
      <motion.div
        initial={{ scale: 0, opacity: 0.9 }}
        animate={{ scale: 2.4, opacity: 0 }}
        transition={{ duration: 0.9, ease: "easeOut" }}
        className="absolute left-1/2 top-1/2 h-24 w-24 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-amber-200/80"
      />

      {/* confetti */}
      {parts.map((p, i) => (
        <motion.span
          key={i}
          initial={{ x: 0, y: 0, rotate: 0, opacity: 1 }}
          animate={{ x: p.x, y: p.y, rotate: p.r, opacity: 0 }}
          transition={{ duration: p.d, ease: "easeOut" }}
          style={{
            position: "absolute",
            left: "50%",
            top: "50%",
            width: p.w,
            height: p.h,
            background: p.c,
            borderRadius: 2,
          }}
        />
      ))}
    </div>
  );
};
